import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid } from '@material-ui/core';
import { REFUND_STATUSES } from 'constants/amcStatuses';

export const StyledCaption = styled(Captions)`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin: 1px !important;
  }
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    font-weight: 500;
    margin-bottom: 0;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;

export const StyledShortBody14 = styled(ShortBody)`
  && {
    color: #9797af;
    font-size: 14px !important;
    margin-top: 5px !important;
  }
`;

export const COLOR_BY_REFUND_STATUS: any = {
  [REFUND_STATUSES.RETURN]: '#fcb718',
  [REFUND_STATUSES.VISITE]: '#fcb718',
  [REFUND_STATUSES.AGREEMENT]: '#6fad37',
  [REFUND_STATUSES.REJECTED]: '#D0021B',
  [REFUND_STATUSES.PAIED]: '#6fad37',
  [REFUND_STATUSES.PEC_CANCELED]: '#D0021B',
  [REFUND_STATUSES.PENDING]: '#fcb718',
  [REFUND_STATUSES.COMPLEMENTARY_INFO]: '#fcb718',
  [REFUND_STATUSES.PEC]: '#fcb718',
  [REFUND_STATUSES.S_SUITE]: '#D0021B',
  DEFAULT: '#fcb718',
};
